import RushContactPage from '../landing/rush/RushContactPage';

const ContactPageWrapper = () => <RushContactPage />;

export default ContactPageWrapper;
